import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import styles from "./header.module.css";

import teploLogo from "../../../files/images/teploLogo.png";
import bigteploLogo from "../../../files/images/biglogo.png";
import mailIcon from "../../../files/icons/mailIcon.png";
import phoneIcon from "../../../files/icons/phoneIcon.png";
import connectIcon from "../../../files/icons/connectIcon.png";
import keyIcon from "../../../files/icons/keyIcon.png";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActiveHeader: false
    };

    this.listenScrollEvent = this.listenScrollEvent.bind(this);
  }
  componentDidMount() {
    window.addEventListener("scroll", this.listenScrollEvent, true);
  }

  listenScrollEvent = e => {
    if (e.srcElement.scrollTop > 10) {
      this.setState({ isActiveHeader: true });
    } else {
      this.setState({ isActiveHeader: false });
    }
  };
    render() {
        const LoginContainer = () => {
            if (this.props.isLogged) {
                return (
                    <div className={styles.loginContainer}>
                        <span>
                            {this.props.user}
                        </span>
                        <Link onClick={this.props.exit}> Выйти </Link>
                    </div>);
            }
            else {
                return (
                    <div className={styles.loginContainer}>
                        <img
                            style={{ width: "1.4vw", marginRight: "0.7vw" }}
                            src={keyIcon}
                            alt="connect icon"
                        />
                        <span>
                            <Link to="/login">
                                <div
                                    style={{
                                        display: "inline-block",
                                        textDecoration: "underline"
                                    }}
                                >
                                    Войти
                        </div>
                            </Link>
                        </span>{" "}
                    /{" "}
                        <Link to="/connection">
                            <span style={{ textDecoration: "underline" }}>
                                Регистрация
                      </span>
                        </Link>
                    </div>);
            }
        };

    return (
      <div
        className={
          this.state.isActiveHeader ? styles.activeHeader : styles.header
        }
      >
        <div className={styles.subHeader}>
          <div
            style={{
              height: "100%",
              width: "100%",
              flex: "2",
              textAlign: "left",
              paddingLeft: "2vw",
              display: "flex"
            }}
          >
            <Link to="/">
              <img
                src={teploLogo}
                style={
                {
                  width: "5.8vw",
                  height: "2.95vw",
                  marginTop: "0.3vw"
                }}
              />
            </Link>
            <table
              style={{
                width: "100%",
                margin: "0px",
                display: "inline-block"
              }}
            >
              <tbody style={{ paddingRight: "7em", float: "right" }}>
                <tr>
                  <td>
                    <img
                      style={{ height: "2em", width: "2em" }}
                      src={connectIcon}
                      alt="connect icon"
                    />
                  </td>
                  <td
                    style={{
                      paddingLeft: "0.4em",
                      textAlign: "left"
                    }}
                  >
                    <Link to="/connection">
                      <div>
                        Подключиться к<br />
                        ИС «Теплоинформ»
                      </div>
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            style={{
              flex: "1"
            }}
          >
            <table style={{ margin: "0 auto" }}>
              <tbody>
                <tr>
                  <td rowSpan="2">
                    <img
                      style={{ height: "2em", width: "2em" }}
                      src={phoneIcon}
                      alt="phone icon"
                    />
                  </td>
                  <td
                    style={{
                      fontWeight: "600",
                      paddingLeft: "0.4em"
                    }}
                  >
                    +7(925)365-59-14
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: "600",
                      paddingLeft: "0.4em"
                    }}
                  >
                    +7(495)672-72-13
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            style={{
              alignItems: "center",
              display: "flex",
              flex: "2",
              textAlign: "right",
              paddingRight: "2vw"
            }}
          >
            <div
              style={{
                flex: "1",
                display: "inline-block",
                float: "left",
                textAlign: "left",
                paddingLeft: "7em"
              }}
            >
              <img
                style={{ height: "1.9em", width: "1.9em" }}
                src={mailIcon}
                alt="email icon"
              />
              <a
                href="mailto:info@teplo-inform.ru?Subject=General"
                target="_top"
                style={{
                  textDecoration: "underline",
                  paddingLeft: "0.4em"
                }}
              >
                info@teplo-inform.ru
              </a>
            </div>
            <div style={{ flex: "1" }}>
                {LoginContainer() }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
